import type { Tutorial } from 'src/app/popups/api/use-user-tutorials'
import { CompleteProfilePopup } from 'src/app/popups/components/complete-profile-popup'
import { IOSDownloadPopup } from 'src/app/popups/components/ios-download-popup'
import { VisibilityPopup } from 'src/app/popups/components/visibility-popup'
import { paths } from 'src/config/paths'
// import { HomeTutorial } from 'src/shared/features/users/components/home-tutorial' // Old Points Popup - deprecate

export type PopupConfig = {
  component: React.ComponentType
  paths: string[]
  tutorialKey?: keyof Tutorial
  showCondition?: () => boolean
}

// Map popups to their respective paths and tutorial keys
export const popupRoutes: PopupConfig[] = [
  {
    component: VisibilityPopup,
    paths: [paths.home.path],
    tutorialKey: 'visibilityTutorial',
  },
  {
    component: CompleteProfilePopup,
    paths: ['*'], // Show on all routes
  },
  {
    component: IOSDownloadPopup,
    paths: ['*'], // Show on all routes
  },
  // Add more popup configurations here as needed
]
